const universitiesDropdownInit = function () {
	const universitiesDropdown = document.getElementById('universities-we-cover');

	if (universitiesDropdown) {
		universitiesDropdown.addEventListener( 'change', function () {
			window.location = this.value;
		} );
	}
};
export default universitiesDropdownInit;
